import * as React from 'react';

import { LabelsList } from '../../../components/LabelsList';
import { useOfferContext } from '../../../context';
import { trackShowRosreestrCheckedLabel } from './tracking';

export function LabelsListContainer() {
  const { labels, jsonQuery, offer, position, isRosreestrCheckedLabelAvailable } = useOfferContext();

  const labelsToShow = [...labels];

  const onShow = React.useCallback(() => {
    if (isRosreestrCheckedLabelAvailable) {
      trackShowRosreestrCheckedLabel(jsonQuery, { offerId: offer.id, position });
    }
  }, [isRosreestrCheckedLabelAvailable, jsonQuery, offer.id, position]);

  if (!labelsToShow.length) {
    return null;
  }

  return <LabelsList labels={labelsToShow} onShow={onShow} />;
}
